import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import SendIcon from '@material-ui/icons/Send';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { t } from 'src/lib/language';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { ENTITIES } from 'src/models/QuerybuilderModel';

interface Props extends ButtonProps {
  eventId?: number;
}

const SendTicketButton = (props: Props) => {
  const { disabled, eventId } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.tickets] || [],
  );

  const handleOpen = () => {
    dispatch(openDialog({
      dialog: DIALOGS.sendTicket,
      payload: { eventId, ticketIds: selections },
    }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.send_ticket')}
      placement="top-start">
      <span>
        <ActionButton
          data-testid="send-ticket-button"
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.download}
          onClick={handleOpen}
          disabled={disabled || !eventId}>
          <SendIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default SendTicketButton;
